export default __webpack_public_path__ + "static/media/tehnical_support_general_logo.d522fb43.svg";